<dt-modal-content size="small" [contentPadding]="false" (closeClick)="close()">
  <ng-template #title i18n>Meine Veranstaltungen</ng-template>
  <ng-template #content>
    <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
    @if (eventSubmissions$ | async; as eventSubmissions) {
      <dt-flex-table [data]="eventSubmissions" (clickRow)="openEventModalForSubmission(eventSubmissions[$event])">
        <dt-flex-column id="name" [flex]="true" i18n-name name="Name" [sortable]="false">
          <ng-template let-submission="$implicit" let-index="index">
            <span>{{ submission.event.name }}</span>
          </ng-template>
        </dt-flex-column>
        <dt-flex-column id="status" i18n-name name="Status" [sortable]="false">
          <ng-template let-submission="$implicit" let-index="index">
            <div class="status-container">
              @switch (getSubmissionState(submission)) {
                @case ('submitted') {
                  <span class="green" i18n>Erfolgreich abgegeben</span>
                  <span class="gray" i18n>Am {{ submission.updatedAt | date: 'short' }}</span>
                }
                @case ('notstarted') {
                  <span i18n>Abgabezeitraum noch nicht begonnen</span>
                  <span class="gray" i18n>Startet am {{ submission.event.startDate | date: 'short' }}</span>
                }
                @case ('expired') {
                  <span class="red" i18n>Abgabezeitraum abgelaufen</span>
                  <span class="gray" i18n>Am {{ submission.event.endDate | date: 'short' }} abgelaufen</span>
                }
                @case ('inprogress') {
                  <span class="orange" i18n>Abgabe möglich</span>
                  @if (submission.event.endDate) {
                    <span class="gray" i18n>Bis zum {{ submission.event.endDate | date: 'short' }}</span>
                  }
                }
              }
            </div>
          </ng-template>
        </dt-flex-column>
      </dt-flex-table>
      <div class="join-event-container">
        <form class="dt-form" [formGroup]="joinEventFormGroup" (ngSubmit)="joinEvent()" #joinEventForm>
          <mat-form-field subscriptSizing="dynamic" [floatLabel]="'always'">
            <mat-label i18n>Neue Veranstaltung</mat-label>
            <input formControlName="code" matInput i18n-placeholder placeholder="Veranstaltungscode" />
            <button mat-button color="accent" matSuffix [disabled]="!joinEventFormGroup.valid || !joinEventFormGroup.value.code" i18n
              >Beitreten</button
            >
          </mat-form-field>
        </form>
      </div>
    } @else {
      <div class="loading-or-error">
        @if (hasError) {
          <mat-error class="dt-error" i18n
            >Beim Laden der Veranstaltungen ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.</mat-error
          >
        } @else {
          <mat-spinner></mat-spinner>
        }
      </div>
    }
  </ng-template>
</dt-modal-content>
